import {Address} from "../../mock-data/address/addresses-data";
import { Media } from "../assets/media";
import { Contact } from "../contact/contact";
import { Enrollment, EnrollmentMode } from "../enrollment/enrollment";
import { Ministry } from "../ministry/ministry";


export enum EventStatus {
  UPCOMING = 'upcoming',
  ONGOING = 'ongoing',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled'
}

export enum EventCategory {
  CONFERENCE = 'conference',
  SPORTS_DAY = 'sports_day',
  MONTHLY_WORSHIP = 'monthly_worship',
  YOUTH_MEETING = 'youth_meeting',
  WORKSHOP = 'workshop',
  GATHERING = 'gathering',
  WORSHIP = 'worship',
  TRAINING = 'training',
  OUTREACH = 'outreach',
  FELLOWSHIP = 'fellowship'
}

export enum EventMetadataType {
  MINISTRY_RECURRING = 'ministry_recurring'
}

export enum RecurrencePattern {
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
  YEARLY = 'yearly'
}

export enum RecurrenceDuration {
  ALL_YEAR = 'all_year',
  SEASONAL = 'seasonal',
  TERM = 'term'
}

export interface EventRecurrence {
  pattern: RecurrencePattern;
  dayOfWeek?: number;
  duration: RecurrenceDuration;
}

export interface MinistryEventMetadata {
  type: EventMetadataType.MINISTRY_RECURRING;
  ministryId: string;
  ministryKey: string;
  recurrence: EventRecurrence;
}

export type EventMetadata = MinistryEventMetadata;

export interface Event {
  id: number;
  key: string;
  title: string;
  description: string;
  shortDescription: string;
  longDescription: string;

  startDate: string;
  endDate: string;
  startTime: string;
  endTime: string;
  timezone: string;

  slug: string;
  tags: string[];

  featured: boolean;

  address: Address;
  enrollment: Enrollment;
  media: Media;
  contactInfo: Contact;
  organizer: Ministry;
  

  category: EventCategory;
  status: EventStatus;


  metadata?: EventMetadata;

  createdAt: string;
  updatedAt: string;
}

export interface EventFilters {
  search?: string;
  category?: EventCategory;
  startDate?: string;
  endDate?: string;
  tags?: string[];
  enrollmentType?: EnrollmentMode;
  status?: EventStatus;
  featured?: boolean;
}

export interface EventViewMode {
  type: 'calendar' | 'list';
  calendarView?: 'month' | 'week' | 'day';
}